import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const dpp_public = apiUrl + "/dpp_public";
const routes = {
  label: "DPP Public",
  root: dpp_public,
  get_published_by_product_id: dpp_public + "/get_published_by_product_id",
  get_published_photo_by_product_id: dpp_public + "/get_published_photo_by_product_id",
};
export const DPP_Public = {
  label: routes.label,
  get_published_by_product_id: (product_id) => postWithToken(routes.get_published_by_product_id, { product_id }),
  get_published_photo_by_product_id: (product_id) => postWithToken(routes.get_published_photo_by_product_id, { product_id }),
};
